import { render, staticRenderFns } from "./default.vue?vue&type=template&id=63646d94"
import script from "./default.vue?vue&type=script&lang=js"
export * from "./default.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutBanner: require('/opt/build/repo/components/Layout/Banner/index.vue').default,LayoutHeader: require('/opt/build/repo/components/Layout/Header/index.vue').default,LayoutHeaderAsideNav: require('/opt/build/repo/components/Layout/Header/AsideNav.vue').default,LayoutPreFooter: require('/opt/build/repo/components/Layout/PreFooter/index.vue').default,LayoutFooter: require('/opt/build/repo/components/Layout/Footer/index.vue').default})
